module.exports = __webpack_public_path__ + "img/unlock-style2.4486d5df.png";